import React, { useEffect, useRef, useState } from 'react';
import LazyLoad from 'react-lazyload';
import { pdfjs, Document, Page } from 'react-pdf/dist/esm/entry.webpack';
import { Spin } from 'antd';

pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.js`;

type Props = {
    loading: boolean;
    file: any;
};

const PDFView: React.FC<Props> = ({ file, loading }) => {
    const fileBlob = useRef<null | Blob>(null);
    const [fileObject, setFile] = useState<string | null>(null);
    const [numPages, setNumPages] = useState<number>(0);

    const onDocumentLoadSuccess = (pdfProps: any) => {
        setNumPages(pdfProps.numPages);
    };

    useEffect(() => {
        if (!loading) {
            let fileBlobObject = new Blob([file], { type: 'application/pdf' });
            fileBlob.current = fileBlobObject;
            let fileURL = window.URL.createObjectURL(fileBlobObject);
            setFile(fileURL);
        }
    }, [file, loading]);

    return (
        <div>
            {fileObject && !loading && (
                <Document
                    file={fileObject}
                    onLoadSuccess={onDocumentLoadSuccess}
                    options={{
                        cMapUrl: `//cdn.jsdelivr.net/npm/pdfjs-dist@${pdfjs.version}/cmaps/`,
                        cMapPacked: true,
                    }}
                >
                    {new Array(numPages).fill('').map((_x, index) => (
                        <LazyLoad placeholder={<Spin />} key={`lazy_loading_${index}_pdf`}>
                            <Page
                                pageIndex={index}
                                renderMode="svg"
                                className="m-auto"
                                loading={<Spin />}
                                renderAnnotationLayer={false}
                                renderTextLayer={false}
                                width={1000}
                            />
                        </LazyLoad>
                    ))}
                </Document>
            )}
            {loading && (
                <div className="flex justify-center items-center min-h-[300px]">
                    <Spin />
                </div>
            )}
        </div>
    );
};

export default PDFView;
